module.exports = __webpack_public_path__ + "img/12.ed810a4e.jpg";